import { Modal, ModalHeader, ModalBody, ModalFooter, Label, Input } from "reactstrap";
import { IPosition } from "../../../../types/position";
import { AddIcon, CancelIcon, CheckIcon } from "../../../common/icons";
import { useEffect, useState } from "react";
import SearchIndividual from "./search-individual";
import CreateIndividualDetail from "./create-individual-details";
import IndividualList from "./individual-list";
import { IAssignIndividualInput, IIndividualLight, IIndividualInput, IPositionAssignment, IUpdateResultResponse, Action, ISearchIndividualsForNewInput, IIndividual, ISearchIndividualsForNewAssignmentResponse, ISearchIndividualsForNewResult } from "../../../../types/individual";
import useToggle from "../../../../hook/useToggle";
import { CREATE_INDIVIDUAL, IS_INDIVIDUAL_NAME_EXISTS, IS_EMAIL_EXISTS, SEARCH_INDIVIDUALS_FOR_NEW_ASSIGNMENT, ASSIGN_INDIVIDUAL } from "../../../../graphql/individual-gql";
import { ApolloCache, useApolloClient, useLazyQuery, useMutation } from "@apollo/client";
import { notifyError, notifySuccess } from "../../../../services/notification";
import { IValueListLight } from "../../../../types/valuelist";
import Select from "../../../common/select/select";
import { ORG_VALUE_LISTS } from "../../../../graphql/valuelist-gql";
import { GET_ORG_POSITIONS, GET_ORG_ROLES, GET_POSITION_ASSIGNMENT, GET_POSITION_DETAIL, GET_ROLE_DETAIL } from "../../../../graphql/position-gql";
import confirm from "../../../common/confirm";
import SpinnerOverlay from "../../../common/spinner/spinner";
import DeactivateAssignmentModal from "../home-position-individual/deactivate-assignment";
import { fullNameAutoFormat } from "../../../../utils/format-fullname";
import { IOrgResponse } from "../../../../types/org";
import { GET_ORG_DETAILS } from "../../../../graphql/org-gql";
import Button from "../../../common/button";

type AssignIndividualProp = {
    position:IPosition;
    isOpen: boolean,
    toggle: ()=>void,

};

const AssignIndividualModal = (prop:AssignIndividualProp) => {

    const {position,isOpen,toggle} = prop;
    const [individuals,setIndividuals] =  useState<Partial<ISearchIndividualsForNewResult>[]>();
    const [createIndividual] = useMutation(CREATE_INDIVIDUAL);
    const [assignIndividual,{loading:assignLoading}] = useMutation<IUpdateResultResponse>(ASSIGN_INDIVIDUAL);
    const [searchIndividual,{loading:searchLoading,error:searchError}] = useLazyQuery<ISearchIndividualsForNewAssignmentResponse>(SEARCH_INDIVIDUALS_FOR_NEW_ASSIGNMENT);
    const [getPositionAssignment,{loading:getPositionAssignmentLoading}] = useLazyQuery(GET_POSITION_ASSIGNMENT,{fetchPolicy:'network-only'})
    const [selectedIndividual,setSelectedIndividual] =  useState<Partial<ISearchIndividualsForNewResult>>();
    const [hasHomeAssignment,setHasHomeAssignment] = useState(false);
    const [checkEmailExists] = useLazyQuery(IS_EMAIL_EXISTS);
    const [checkIndividualNameExists] = useLazyQuery(IS_INDIVIDUAL_NAME_EXISTS);
    const [selectedIndividualId,setSelectedIndividualId] =  useState<number>(0);
    const client = useApolloClient()
    const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})
    const [assignIndividualInput, setAssignIndividualInput] = useState<Partial<IAssignIndividualInput>>(
        {
            assignmentTypeId:position.isRole?(orgValueLists?.roleIndAssignmentTypes[0] as IValueListLight).id:(orgValueLists?.indAssignmentTypes[0] as IValueListLight).id,
            individualId:0,
            positionId:position.positionId,
            acting:false
        });
    const [isContinue,setIsContinue] = useState(false);
    const { isOpen : isCreateIndividualOpen, toggle : createToggle } = useToggle()
    const [actingEnable,setActingEnable] =  useState(false);
    const onToggle = () => {
        isCreateIndividualOpen && createToggle();
        toggle();
    }
    const { isOpen : isDeactivateOpen, toggle : deactivateToggle } = useToggle()
    const [activeHomeIndividual,setActiveHomeIndividual] = useState<IIndividual>();

    const [getOrgDetail, { data: orgDetail }] = useLazyQuery<IOrgResponse>(GET_ORG_DETAILS)

    useEffect(()=>{
        setIndividuals(undefined);
        setActingEnable(false)
        setSelectedIndividual(undefined)
        setAssignIndividualInput({
            assignmentTypeId: position.isRole?(orgValueLists?.roleIndAssignmentTypes[0]).id:
                    (hasHomeAssignment?
                        (orgValueLists?.indAssignmentTypes[1].id):(orgValueLists?.indAssignmentTypes[0].id)),
            individualId:0,
            positionId:position.positionId,
            acting:false
        })
    },[toggle,hasHomeAssignment])

    useEffect(()=>{
        setAssignIndividualInput({...assignIndividualInput,individualId:selectedIndividual?.individualId||0})
    },[selectedIndividual])

    useEffect(()=>{
        setAssignIndividualInput(
            {...assignIndividualInput,
                positionId:position.positionId,
                assignmentTypeId: position.isRole?(orgValueLists?.roleIndAssignmentTypes[0]).id:
                    (hasHomeAssignment?
                        (orgValueLists?.indAssignmentTypes[1].id):(orgValueLists?.indAssignmentTypes[0].id))
            })
    },[hasHomeAssignment])

    useEffect(()=>{
        const homeindividual = position.individuals?.filter(indi=>indi.assignmentType==='Home')
        setHasHomeAssignment(homeindividual&&homeindividual.length!==0)
        getOrgDetail({ variables: { id: position?.orgId },onCompleted:(data)=>{
            //console.log("orgDetailData:",data)
        } })

    },[position])

    const actingCheckboxChange = () => {
        setAssignIndividualInput({...assignIndividualInput,acting:!assignIndividualInput.acting})
    }

    const onSearchIndividualHandle = (searchIndividualsInput:ISearchIndividualsForNewInput) => {
        triggerSearch(searchIndividualsInput);
    }

    const triggerSearch = (searchIndividualsInput:ISearchIndividualsForNewInput) => {
        searchIndividual({
            variables: {input:searchIndividualsInput},
            fetchPolicy: "network-only"
        }).then(response=>{
            const homeindividual = position.individuals?.filter(indi=>indi.assignmentType==='Home')
            //console.log("homeindividual:",homeindividual)
            let individuals = response.data?.searchIndividualsForNewAssignment.individuals;
            
            if(homeindividual&&homeindividual.length>0){
                individuals = response.data?.searchIndividualsForNewAssignment.individuals.filter((item:ISearchIndividualsForNewResult)=>item.individualId!==homeindividual[0].individualId)
                //console.log("individuals:",individuals)
            }
            setIndividuals(individuals);
        })
    }

    const onSelectIndividualHandle = (individual : Partial<ISearchIndividualsForNewResult>| undefined) => {
        setSelectedIndividual(individual)
    }

    const onAssignHandle = async () => {
        //console.log("assignIndividualInput:",assignIndividualInput)
        const { data } = await getPositionAssignment({variables:{positionId:position.positionId}})
        //console.log("data:",data)
        const activeHome = data.position?.individuals?.find((item:IIndividual)=>item.assignmentType ==='Home' && item.indStatus === 'Active') 
        setActiveHomeIndividual(activeHome)
        assignIndividual({variables:{positionId:position?.positionId,action:Action.ADD_VALIDATION,input:assignIndividualInput}}).then((addValidationResponse)=>{
            if(addValidationResponse.data?.assignIndividual){
                confirm({
                    title: 'Warning!',
                    content:  addValidationResponse.data.assignIndividual.message,
                    titleCenter: true,
                    bodyCenter: true,
                    showCancel: false,
                    okText: 'Close',
                    okIcon:<CancelIcon/>
                })
            }else{
                assignIndividual({variables:{positionId:position?.positionId,action:Action.ADD_AUTOMATION,input:assignIndividualInput}}).then((addAutomationResponse)=>{
                    if(addAutomationResponse.data?.assignIndividual){
                        const confirmContent = addAutomationResponse.data?.assignIndividual.message;
                        automationConfirm(confirmContent).then(() => {                        
                            if(activeHome) deactivateToggle()
                            else assignmentExecution()
                        })
                    }else{
                        if(activeHome) deactivateToggle()
                        else assignmentExecution()
                    }
                })
            }
        })
    }

    const assignmentExecution = async (reasonId?:number) => {
        
        try {
          const { data } = await assignIndividual({
            variables: { positionId:position?.positionId,action: Action.ADD, input: assignIndividualInput },
            refetchQueries: getRefetchQuery(),
            awaitRefetchQueries: true,
            update(cache,{data}){
                
                if(data?.assignIndividual && activeHomeIndividual && reasonId){
                  // console.log("data:",data)
                  const selectReason = orgValueLists.posStatusReason.filter((valueList: IValueListLight)=>valueList.id===reasonId)[0];
                  const updatedIndi:IIndividual = {...activeHomeIndividual,indStatus:'Inactive',indStatusReason:{...selectReason}}
                  updatCache(cache,updatedIndi)
                }
            }
          });

          if (data?.assignIndividual?.success && data.assignIndividual.message) {
            const updatedAssignment: IPositionAssignment = JSON.parse(data.assignIndividual.message);

            const editedIndi = individuals?.find(indi => indi.individualId === assignIndividualInput.individualId);
            if (editedIndi) {
              const newIndi: Partial<ISearchIndividualsForNewResult> = { ...editedIndi };

              if (updatedAssignment) {
                //console.log("updatedAssignment:",updatedAssignment)
                //newIndi.assignments = { ...,...response.individual.positionAssignments };
              }

              const newIndividuals: Partial<IIndividualLight>[] = individuals ? [newIndi, ...individuals] : [newIndi];

              setIndividuals(newIndividuals);
            }

            data && notifySuccess();
          } else if (data?.assignIndividual?.message) {
            notifyError(data.assignIndividual.message);
          }

          setSelectedIndividualId(0);
          setSelectedIndividual(undefined);
          toggle();
        } catch (error:any) {
          console.error("Mutation error:", error.message);
          notifyError('An error occurred while assigning an individual.');
        }
    };


    const onOpenIndividualDetailHandle = () => {
        createToggle()
    }

    const onCreateIndividualHandle =(individualInput:IIndividualInput) => {
        if(isContinue){
            triggerCreateIndividual(individualInput)
        }else{
            triggerSearch({individualName:`${individualInput.firstName} ${individualInput.lastName}`,orgId:0})
            Promise.all([
                checkEmailExists({variables:{email:individualInput.email},fetchPolicy: "network-only"}),
                checkIndividualNameExists({variables:{firstName:individualInput.firstName,lastName:individualInput.lastName},fetchPolicy: "network-only"})
            ]).then(results => {
                if(results[0].data?.isIndividualEmailExists){
                    notifyError('Cannot create a new individual because the entered email address is already in use.')
                }else if(results[1].data?.isIndividualNameExists){
                    setIsContinue(true);
                    notifyError('There are already Individuals in the system with the same first and last name. If you want to use an existing individual, please select them from the list and click "Assign". If you would still like to create a new individual, click on the "Create" button.')
                }else{
                    triggerCreateIndividual(individualInput)
                }
            })
            .catch(error => {
                console.error('An error occurred:', error);
                notifyError('An error occurred while checking individual name and email.');
            });
        }
    }

    const triggerCreateIndividual = (individualInput:IIndividualInput) => {
        createIndividual({
            variables:{input:individualInput},

            onCompleted: (data) => {
                const newIndi : Partial<ISearchIndividualsForNewResult> =  {
                        individualId:data.createIndividual.individualId,
                        fullName:data.createIndividual.individualFullName,
                        emails:data.createIndividual.email,
                        primaryEmail:data.createIndividual.email
                    }
                const newIndividuals: Partial<ISearchIndividualsForNewResult>[] = individuals
                    ? [newIndi,...individuals ]
                    : [newIndi];

                setSelectedIndividualId(newIndi.individualId||0)
                setIndividuals(newIndividuals)
                setSelectedIndividual(newIndi)
                data && notifySuccess()
            },
            onError: (error) => {
              console.error("Mutation error:", error.message);
              notifyError('An error occurred while creating new individual.')
            },
        })
        setIsContinue(false)
        createToggle()
    }

    const onAssignmentTypeChange = (event:any) =>{
        const assignTypeCode = orgValueLists?.indAssignmentTypes.filter((type:IValueListLight)=>
            type.id===event.target.value
        )[0]?.code;
        const isActingType = assignTypeCode==='SECONDMENT' ||assignTypeCode==='FIXEDTERM' ||assignTypeCode==='LINK';
        setAssignIndividualInput({...assignIndividualInput,assignmentTypeId:event.target.value})
        setActingEnable(isActingType )
    }

    const getRefetchQuery = () => {
        let queries: any = []
        if(position?.isRole)
            queries = [...queries,{query:GET_ROLE_DETAIL,variables: { roleId: position.positionId }}]
        else
            queries = [...queries,{query:GET_POSITION_DETAIL,variables: { positionId: position.positionId }}]
        if(position?.orgId){
            if(position?.isRole){
                queries= [...queries,{query: GET_ORG_ROLES, variables: { orgId: position.orgId }}]
            }else
                queries= [...queries,{query: GET_ORG_POSITIONS, variables: { orgId: position.orgId }}]
        }
        if(orgDetail?.org.sharedToOrgIds){
            orgDetail.org.sharedToOrgIds.split(',').forEach(orgId=>{
                if(position?.isRole)
                    queries = [...queries,{query:GET_ORG_ROLES,variables:{orgId}}]
                else
                    queries = [...queries,{query:GET_ORG_POSITIONS,variables:{orgId}}]
            })
        }

        return queries;
    }

    const automationConfirm =(content:string)=> confirm({
        title: 'Confirmation',
        content: content,
        okText: <><CheckIcon/> OK</>,
        okBtnColor: 'primary',
        titleCenter: true,
        bodyCenter: true
    })

    const onDeactivateConfirm = (reasonId?:number) =>{
        assignmentExecution(reasonId);
        //const deactiveInput:IAssignIndividualInput = {assignmentId:activeHomeIndividual?.positionAssignmentId,reasonId:reasonId}
        //console.log("deactiveInput:",deactiveInput)
    
        /*assignIndividual({
          variables:{positionId:position?.positionId,action:Action.DEACTIVATION,input:deactiveInput},
          update(cache,{data}){
            if(data?.assignIndividual && activeHomeIndividual){
              const selectReason = orgValueLists.posStatusReason.filter((valueList: IValueListLight)=>valueList.id===reasonId)[0];
              const updatedIndi:IIndividual = {...activeHomeIndividual,indStatus:'Inactive',indStatusReason:{...selectReason}}
              updatCache(cache,data,updatedIndi)
            }
          }
        })*/
    }

    const updatCache = (cache : ApolloCache <any>, indi?:IIndividual) =>{
        const cachedOrg = cache.readQuery<{
          org:{
              positions:Array<IPosition>
          }
        }>({
          query: GET_ORG_POSITIONS,
          variables: { orgId: position?.orgId},
        });
    
        if(cachedOrg){
    
            let updatedPositions = [...cachedOrg.org.positions];
            const updatedPositionIndex = updatedPositions.findIndex(
                (pos: IPosition) => pos.positionId === position.positionId
              );
    
            if (updatedPositionIndex !== -1) {
                const indiIndex = updatedPositions[updatedPositionIndex].individuals.findIndex(
                  (individual:IIndividual) => individual.individualId === indi?.individualId
                )
                if(indiIndex!==-1){
    
                    let updatedIndividuals = [...updatedPositions[updatedPositionIndex].individuals]
    
                    if(indi){
                      updatedIndividuals[indiIndex]=indi;
                    }else{
                      updatedIndividuals.splice(indiIndex, 1);
                    }
    
                    updatedPositions[updatedPositionIndex]={
                      ...updatedPositions[updatedPositionIndex],
                      individuals: updatedIndividuals
                    };
    
                }
            }
            // Update the cached data with the modified positions array
            cache.writeQuery({
                query: GET_ORG_POSITIONS,
                variables: { orgId:  position?.orgId },
                data: {
                    org: {
                        ...cachedOrg.org,
                        positions: updatedPositions,
                    },
                },
            });
    
        }
      }

    return(<>
        {activeHomeIndividual && <DeactivateAssignmentModal isOpen={isDeactivateOpen} toggle={deactivateToggle}
            onConfirm={onDeactivateConfirm}
            individual={activeHomeIndividual}
            fullPositionName={position?.fullPositionName}
            reasonList={orgValueLists.posStatusReason}
        />}
        {assignLoading && <SpinnerOverlay />}
        <Modal  size="lg" isOpen={isOpen} toggle={onToggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={onToggle} tag={'h2'}>Assign Individual to {position.isRole?'Role':'Position'}</ModalHeader>
            <ModalBody>
            <div className="wrapper tooltipOMSContainer">
                <div>
                    <div>Please select a type of assignment you would like to assign an individual to for this position.</div>
                    <br/>
                    <div className='row'>
                        <div className="col-4"><Label for="assignmentType">Assignment Type: (required)</Label></div>
                        <div className="col-8">
                            <Select id="assignmentType" value={assignIndividualInput?.assignmentTypeId || 0} onChange={(event:any)=>onAssignmentTypeChange(event)} autoFocus={true}>
                                {position.isRole?
                                    orgValueLists.roleIndAssignmentTypes
                                    .map((item: IValueListLight) => (
                                    <option key={item.id} value={item.id}>
                                        {item.label}
                                    </option>
                                    ))
                                    :orgValueLists.indAssignmentTypes
                                        .filter((item: IValueListLight) => hasHomeAssignment ? (item.code !== 'DIRECT'):true)
                                        .map((item: IValueListLight) => (
                                        <option key={item.id} value={item.id}>
                                            {item.label}
                                        </option>
                                    ))
                                }
                            </Select>
                        </div>
                    </div>
                    {actingEnable &&
                        <div className='row'>
                            <div className="col-4"><Label for="actingCheckbox">Acting position?</Label></div>
                            <div className="col-8">
                                <Input type="checkbox"
                                    id="actingCheckbox"
                                    aria-label="Acting Position"
                                    checked={assignIndividualInput.acting}
                                    onChange={() => actingCheckboxChange() }
                                    disabled={!actingEnable}
                                />
                            </div>
                        </div>
                    }
                </div>

                <hr style={{color: "black",backgroundColor: "black"}}/>

                <SearchIndividual onSearchIndividual={onSearchIndividualHandle} onCreateNewIndividual={onOpenIndividualDetailHandle} isRole={position.isRole}></SearchIndividual>

                {isCreateIndividualOpen&&<CreateIndividualDetail toggle={createToggle} onCreate={onCreateIndividualHandle} createButtonChange={setIsContinue} ></CreateIndividualDetail>}

                <IndividualList onSelect={onSelectIndividualHandle} individuals={individuals||[]} selectedIndividualId={selectedIndividualId} loading={searchLoading} error={searchError}></IndividualList>
            </div>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onAssignHandle} disabled={assignIndividualInput.individualId===0}>
                    <AddIcon/> Assign
                </Button>
                <Button color="secondary" onClick={onToggle}>
                    <CancelIcon/> Cancel
                </Button>

            </ModalFooter>
        </Modal>
    </>
    )

}

export default AssignIndividualModal;
